 function bundlyAddLinksToSlots() {
    const slotTitles = document.querySelectorAll('.bundly__slot_title');
    slotTitles.forEach(slotTitle => {
      const baseUrl = slotTitle.closest('.bundly__block').dataset.url;
      const slotComponentIndex = slotTitle.closest('.bundly__slot').dataset.componentIndex;
      const urlState = Bundly.urlStateBuilder.buildStateWithParams({ currentComponentIndex: slotComponentIndex });
      const link = document.createElement('a');
      link.href = `${baseUrl}/${urlState}`;
      slotTitle.parentNode.insertBefore(link, slotTitle);
      link.appendChild(slotTitle);
    });
  }

  window.addEventListener('load', () => {  
    bundlyAddLinksToSlots();
  });
  document.addEventListener('bundly:afterUpdateBlock', () => {
    bundlyAddLinksToSlots();
  });

  /* Auswahlmenü mobil verkleinert Anzeigen (Sichtbarkeit Produkte) */
document.addEventListener('bundly:beforeUpdateBlock', (e) => {
  e.detail.serverResponse = e.detail.serverResponse.replaceAll('bundly__details bundly__details--visible', 'bundly__details');
});


// custom.js
(function() {



  
  // Entfernt <a> und (bei header) fügt toggle-Klasse hinzu
  function cleanBundly(root = document) {
   
    
    // Alle Slot-Titel sammeln
    const slotTitles = document.querySelectorAll('.bundly__slot_title');
    const reihenfolge = [];

    slotTitles.forEach(slot => {
      // In jedem Slot den Produkttitel suchen
      const prod = slot.querySelector('.bundly__slot_product_title');
      if (prod && prod.textContent.trim()) {
        reihenfolge.push(prod.textContent.trim());
      }
    });

    // Label finden und den Text erweitern
    const lbl = document.getElementById('assembly-label');
    if (lbl && reihenfolge.length) {
      lbl.textContent = lbl.textContent + ': ' + reihenfolge.join(', ');
    }

    // 2) Komponententitel
    root.querySelectorAll('.bundly__component_title').forEach(function(div) {
      var link = div.querySelector('a');
      if (link) {
        div.textContent = link.textContent.trim();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    // initial
  

    cleanBundly();

    // MutationObserver auf ganzes Dokument verschieben
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            // Neu eingefügte Knoten checken
            cleanBundly(node);
          }
        });
      });
    });

    // Beobachte documentElement, sobald es existiert
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }, { once: true });  // optional: listener nach erstem Aufruf automatisch entfernen
})();

